import { Box, Field as ChakraField, HStack, VStack } from '@chakra-ui/react';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  labelProps?: ChakraField.LabelProps;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  layout?: 'vertical' | 'horizontal';
  labelWidth?: string;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const {
    label,
    children,
    helperText,
    errorText,
    optionalText,
    labelProps,
    layout = 'vertical',
    labelWidth = '200px',
    ...rest
  } = props;

  if (layout === 'horizontal') {
    return (
      <ChakraField.Root ref={ref} {...rest}>
        <HStack align="center" gap={4}>
          {label && (
            <Box w={labelWidth} flexShrink={0} pt="2px">
              <VStack align="stretch" gap={1}>
                <ChakraField.Label {...labelProps}>
                  {label}
                  <ChakraField.RequiredIndicator />
                  <ChakraField.HelperText>{optionalText}</ChakraField.HelperText>
                </ChakraField.Label>
                {helperText && (
                  <ChakraField.HelperText fontSize="xs" color="fg.muted">
                    {helperText}
                  </ChakraField.HelperText>
                )}
              </VStack>
            </Box>
          )}
          <VStack align="stretch" gap={1} flex="1">
            {children}
            {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
          </VStack>
        </HStack>
      </ChakraField.Root>
    );
  }

  return (
    <ChakraField.Root ref={ref} {...rest}>
      <VStack align="stretch" gap={1}>
        {label && (
          <ChakraField.Label flex="1" {...labelProps}>
            {label}
            <ChakraField.RequiredIndicator />
            <ChakraField.HelperText>{optionalText}</ChakraField.HelperText>
          </ChakraField.Label>
        )}
        {helperText && <ChakraField.HelperText fontSize="xs">{helperText}</ChakraField.HelperText>}
      </VStack>
      {children}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  );
});
